import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Edit } from '@material-ui/icons'
import { useKeycloak } from '@react-keycloak/web'

import SimpleInputField from '../../../../PropertySearch/Custom/CustomInput/SimpleInputField'
import listContext from '../../../../Common/context/context'
import searchContext from '../../../../PropertySearch/FiltersComponent/context/context'
import { getUserSFId, viewList, getErrorAlertDuration } from '../../../../PropertySearch/Utility/Utility'
import updatePropertyList from '../../../Utility/UpdatePropertyList/UpdatePropertyList'
import { pollMessageStatus } from '../../../Utility/GetMessageStatus/GetMessageStatus'

const ClonePropertyList = props => {

    const { keycloak } = useKeycloak()
    let { propertyList, setPropertyListId } = useContext(listContext)
    const { propertyDetailList } = props
    const { savedLists, setShowAlert, setalertProps, setSelectedMenu, fetchSavedLists, openModalWindow } = useContext(searchContext)
    const [saveClicked, setSaveClicked] = useState(false)
    let [listName, setListName] = useState('')


    useEffect(() => {
        if (saveClicked) {
            handleSave()
        }
    }, [saveClicked])

    useEffect(() => {
        if (propertyDetailList)
            setListName(`${propertyDetailList.name} - copy`)
        else
            setListName(`${propertyList.name} - copy`)
    }, [propertyDetailList])

    function handleChange(e) {
        let { value } = e.target
        setListName(value)
    }

    const getPayload = () => {
        let newPropertyList = { ...propertyList }

        if (propertyDetailList)
            newPropertyList = { ...propertyDetailList }

        const user_SFId = getUserSFId();

        let compsList = []
        let fieldsToUpdate = []

        newPropertyList.compsList.forEach(element => {
            compsList.push({
                omniViewPropertyId: element.omniViewPropertyId,
                isSubjectProperty: element.isSubjectProperty,
                rank: element.rank ? element.rank : 1,
                action: "add"
            })
        });

        fieldsToUpdate.push({ key: 'ownerId', value: user_SFId })
        fieldsToUpdate.push({ key: 'userId', value: keycloak.subject })
        fieldsToUpdate.push({ key: 'omniViewUserId', value: user_SFId })
        fieldsToUpdate.push({ key: 'name', value: listName })
        fieldsToUpdate.push({ key: 'compType', value: newPropertyList.compType })
        fieldsToUpdate.push({ key: 'polarisSearchCriteria', value: '' })
        fieldsToUpdate.push({ key: 'compsList', value: compsList })
        fieldsToUpdate.push({ key: 'average', value: true })
        fieldsToUpdate.push({ key: 'highLow', value: false })
        fieldsToUpdate.push({ key: 'effectiveRents', value: false })
        fieldsToUpdate.push({ key: 'marketRents', value: true })
        fieldsToUpdate.push({ key: 'polarisUserName', value: keycloak.tokenParsed.name })

        return fieldsToUpdate
    }
    const handleViewList = (newListId) => {

        viewList(newListId, '', setSelectedMenu)

        if (propertyList) {
            setPropertyListId({
                polarisPropertySearchCriteriaId: newListId,
                omniViewPropertyListId: ''
            })
        }
    }
    const createAlert = data => {

        return (
            <>
                <span>
                    List Cloned<span><a className="btn btn-link underline" onClick={() => handleViewList(data)}><strong>View</strong></a></span>
                </span>
            </>
        )
    }

    const onRecordCreation = async (message, type) => {

        try {

            if (type === 'success') {
                await fetchSavedLists()
            }
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in onRecordCreation :: ', error)
        }

    }

    const handleSave = async () => {
        try {
            listName = listName.trim().replace('[ \t]+$')
            let index = savedLists.findIndex(x => x.name === listName && x.isCart)
            if (index !== -1) {
                let msg = <>List with Name <strong>{listName}</strong> already exist!!</>
                setalertProps({ message: msg, type: 'error' })
                setShowAlert(true)
                setSaveClicked(false)
                return
            }

            openModalWindow(true)
            props.closeModal()
            const updatePropertyListObj = new updatePropertyList(getPayload(), "add")
            const response = await updatePropertyListObj.update()

            setSaveClicked(false)

            if (response && response.status === 200) {
                let messageId = response.data.messageId
                pollMessageStatus(messageId, onRecordCreation, createAlert, '', 'Unable to fetch list details. Please refresh and open list from Saved lists')

            } else {
                const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                setalertProps({ message: errorMessage, type: 'error' })
                setShowAlert(true)
            }

        }
        catch (e) {
            console.log('Error handleSave:: ', e)
        }
    }

    return (
        <>
            <div data-testid="test-div-container-clone-list" className='flex flex-col py-4 gap-4 drawer-w'>
                <div className='flex flex-row border-b-1 border-base px-4 pb-2'>
                    <span className='pb-4'>
                        <Edit fontSize="small" />
                    </span>
                    <span className='px-2'>
                        Clone Property list
                    </span>
                </div>
                <div className='pt-4 pb-8 border-b-1 border-base px-8 flex flex-col gap-2'>
                    <div className="mb-3">
                        <SimpleInputField data-testid='test-input-clone-list' value={listName} onChange={handleChange} type='' placeholder=''></SimpleInputField>
                    </div>
                </div>
                <div className='py-2 px-4'>
                    <div className='flex justify-end space-x-4 mt-auto'>
                        <div>
                            <button data-testid='test-button-cancel' onClick={props.closeModal} className='btn btn-sm' type='button'>Close</button>
                        </div>
                        <div>
                            {saveClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Cloning</span>
                                </button>
                                :
                                <button data-testid='test-button-apply' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary ${listName.length === 0 ? 'c-disabled' : ''}`}>Clone list</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ClonePropertyList
